module.exports = __webpack_public_path__ + "img/back_idol_call3.835e3cca.png";